// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__7blBZ","container":"Footer_container__TS4nh","withSidePadding":"Footer_withSidePadding__Bm0r4"};